import React from 'react';
import { Link } from 'react-router-dom'
import logo from '../../assets/logo.png';

import './header.styles.scss';

const Header = ()  => (
	<div className='header'>
		<Link to="/"><img src={logo} alt={"logo"} className='logo' to="/" /></Link>
		<div className='menu'>
			<Link className='option' to="/" >Inicio</Link>
			<Link className='option' to="/services" >Servicios</Link>
			<Link className='option' to="/plans" >Planes</Link>
			<Link className='option' to="/contact" >Contacto</Link>
		</div>		
	</div>
);

export default Header;